
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_EQUIPMENT_STATUSES: (state, payload) => state.equipmentStatuses = payload,
}